import { render, staticRenderFns } from "./VoiceAgentCallMessage.vue?vue&type=template&id=224ab002&scoped=true"
import script from "./VoiceAgentCallMessage.vue?vue&type=script&lang=js"
export * from "./VoiceAgentCallMessage.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgentCallMessage.vue?vue&type=style&index=0&id=224ab002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ab002",
  null
  
)

export default component.exports